import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import { Dropdown } from 'react-bootstrap';

type Option = {
  id: string
  label: ReactNode
  icon?: ReactElement
};

type DropdownColumnrops = {
  value?: string
  onChange: ( value?: string ) => void
  options: Option[]
  placeholder?: ReactNode
};

function DropdownColumn( {
  value, onChange, options, placeholder,
}: DropdownColumnrops ) {
  const [selectedValue, setSelected] = useState<string | undefined>( value );

  const handleChange = ( newValue: string ) => {
    setSelected( newValue );
    onChange( newValue );
  };

  const selected = useMemo( () => options.find(
    ( item ) => item.id === selectedValue,
  ), [selectedValue] );

  return (
    <Dropdown className="table-dropdown" drop="down-centered">
      <Dropdown.Toggle variant="link" className="table-dropdown-btn">
        {selected?.icon || selected?.label || placeholder}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map( ( item ) => (
          <Dropdown.Item
            key={item.id}
            onClick={() => handleChange( item.id )}
          >
            {item.label}
          </Dropdown.Item>
        ) )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownColumn;
